module.exports = __webpack_public_path__ + "media/images/favicon/android-chrome-384x384-test-e1c35d79965ecbb1dc479a9a27dd8297.png";